module.exports = __webpack_public_path__ + "static/img/icon_swipe_02.be3b627.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swipe_02.png
// module id = HOWf
// module chunks = 1